var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classname,attrs:{"id":_vm.id},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('mcc-icon',{attrs:{"name":_vm.icon,"aria-hidden":"true"}}):_vm._e(),_c('span',{staticClass:"mcc-button__label"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }